import { Euler, Matrix4, Vector2, Vector3 } from 'three';
import { call } from 'three/examples/jsm/nodes/Nodes.js';

import { EVENTS } from '../../constants.js';
import { globalUniforms } from '../../utils/uniforms.js';

import { lisa } from '../../Lisa.js';
import PBRMaterial from '../PBR/PBR.js';
import replacesFs from './replaces.fs?hotReplace';
import replacesVs from './replaces.vs?hotReplace';

export default class Skin extends PBRMaterial {
	_m4 = new Matrix4();
	_rotation = new Euler();

	constructor(config, caller) {
		config.envMapIntensity = 1;
		config.ambientIntensity = 1.1;
		config.normalScale = new Vector2(1.2, 1.2);
		config.roughness = 0.42;
		super(config, caller);

		this.uniforms.tSmoothSkin = { value: null };
		this.uniforms.tPoresNormal = { value: null };
		this.uniforms.tNoise = { value: null };
		this.uniforms.uDarkMode = globalUniforms.uDarkMode;
		replacesFs.use(this);
		replacesVs.use(this);

		lisa.state.on(EVENTS.ATTACH, this.#onAttach);
		lisa.state.on(EVENTS.DETACH, this.#onDetach);
	}
	#onAttach = () => {
		this.uniforms.tSmoothSkin.value = lisa.scene.lisa.atlas.get('poresMap');
		this.uniforms.tPoresNormal.value = lisa.scene.lisa.atlas.get('poresNormalMap');
		this.uniforms.tNoise.value = lisa.scene.lisa.atlas.get('noiseMap');
	};
	#onDetach = () => {
		lisa.state.off(EVENTS.ATTACH, this.#onAttach);
		lisa.state.off(EVENTS.DETACH, this.#onDetach);
	};
}
